export let Nationality = /*#__PURE__*/function (Nationality) {
  Nationality["Belgian"] = "belgian";
  Nationality["Ue"] = "ue";
  Nationality["NonBe"] = "non_be";
  return Nationality;
}({});